import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export const Bonuses = () => {
  const bonuses = [{
    title: 'Plantillas Aesthetic para Instagram',
    value: '$15.000'
  }, {
    title: 'Guía: Cómo conseguir tus primeras 10 clientas',
    value: '$12.000'
  }, {
    title: 'Lista secreta de proveedores premium',
    value: '$20.000'
  }, {
    title: 'Entrenamiento: Mentalidad de dueña de negocio',
    value: '$25.000'
  }, {
    title: 'Recetario: Las 5 velas más fáciles de vender',
    value: '$10.000'
  }];
  return <section className="py-24 bg-text-dark text-cream relative overflow-hidden" data-id="element-15">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-soft via-transparent to-transparent" data-id="element-16" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-17">
        <FadeIn className="text-center mb-16" data-id="element-18">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-soft/20 text-gold-light text-sm font-medium mb-6 border border-gold-soft/30" data-id="element-19">
            <Gift className="w-4 h-4" data-id="element-20" />
            <span data-id="element-21">Regalos Exclusivos</span>
          </div>
          <h2 className="text-4xl md:text-5xl mb-4 text-white" data-id="element-22">
            Llevate todo esto{' '}
            <span className="text-gold-soft italic" data-id="element-23">HOY GRATIS</span>
          </h2>
          <p className="text-xl text-cream/70" data-id="element-24">
            Al inscribirte hoy, desbloqueás estos bonos de acción rápida.
          </p>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-25">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-26">
              <div className="flex items-center justify-between p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-id="element-27">
                <div className="flex items-center gap-4" data-id="element-28">
                  <div className="w-10 h-10 rounded-full bg-gold-soft/20 flex items-center justify-center shrink-0" data-id="element-29">
                    <Gift className="w-5 h-5 text-gold-light" data-id="element-30" />
                  </div>
                  <h3 className="text-lg md:text-xl font-medium" data-id="element-31">
                    {bonus.title}
                  </h3>
                </div>
                <div className="text-right shrink-0 ml-4" data-id="element-32">
                  <span className="block text-sm text-cream/50 line-through" data-id="element-33">
                    Valor: {bonus.value}
                  </span>
                  <span className="block text-gold-soft font-bold" data-id="element-34">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};